function RootLoader() {
  return (
    <div className="loader-wrapper is-active">
      <div className="loader is-loading" />
    </div>
  );
}

export default RootLoader;
